import axios from 'axios';
import Vue from 'vue';
import App from './App.vue';
import store from './store';
import router from './router';
import Antd from 'ant-design-vue';
import { BreakpointPlugin } from 'vue-breakpoint';

import 'ant-design-vue/dist/antd.css';
import './assets/global.scss';

Vue.config.productionTip = false;

Vue.use(Antd);
Vue.use(BreakpointPlugin);
Vue.use(BreakpointPlugin, {
    xsUp: { minWidth: '0px' },
    xsDown: { maxWidth: '575px' },
    xsOnly: { maxWidth: '575px' },
    smUp: { minWidth: '576px' },
    smDown: { maxWidth: '767px' },
    smOnly: { minWidth: '576px', maxWidth: '767px' },
    mdUp: { minWidth: '768px' },
    mdDown: { maxWidth: '991px' },
    mdOnly: { minWidth: '768px', maxWidth: '991px' },
    lgUp: { minWidth: '992px' },
    lgDown: { maxWidth: '1199px' },
    lgOnly: { minWidth: '992px', maxWidth: '1199px' },
    xlUp: { minWidth: '1200px' }
});

const trackerEndpoint = process.env.VUE_APP_INTERNAL_TRACKER_END_POINT;

Vue.config.errorHandler = (err, vm, info) => {
    let errorObj = {
        err: {
            name: err.name,
            stack: err.stack.toString(),
            message: err.message
        },
        componentName: vm.$options.name,
        lifecycle: info,
        browserInfo: {
            appVersion: window.navigator.appVersion,
            userAgent: window.navigator.userAgent,
            platform: window.navigator.platform
        }
    };

    let token = window.localStorage.getItem('accessToken');

    if (token) errorObj.token = token;

    if (trackerEndpoint) {
        axios.post(trackerEndpoint, { ...errorObj });
    }
};

new Vue({
    store,
    router,
    render: h => h(App)
}).$mount('#app');

window.onerror = function(message, source, lineno, colno, error) {
    let errorObj = {
        err: {
            source: source,
            message: message,
            lineno: lineno,
            colno: colno
        },
        browserInfo: {
            appVersion: window.navigator.appVersion,
            userAgent: window.navigator.userAgent,
            platform: window.navigator.platform
        },
        componentName: 'outside vue component'
    };

    if (error) {
        errorObj.err = error.toString();
    }

    let token = window.localStorage.getItem('accessToken');

    if (token) errorObj.token = token;

    if (trackerEndpoint) {
        axios.post(trackerEndpoint, { ...errorObj });
    }
};
